import { Component, HostListener, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShortNumberPipe } from '../../../../pipes/short-number.pipe';
import { PercentagePipe } from '../../../../pipes/percentage.pipe';
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';
import { round } from '../../../../utils/numbers';
import { ImpressionsRangePipe } from '../../../../pipes/impressions-range.pipe';
import { CreativeGalleryDetailed, GalleryNavigation } from '../../types';
import { UtilService } from '../../../../services/util.service';
import { ATTENTION_METRIC_NAME } from '../../../../shared/types/common';

@Component({
  selector: 'app-creative-card-modal',
  imports: [ImpressionsRangePipe, PercentagePipe, AssetVersionPipe],
  providers: [ShortNumberPipe, PercentagePipe],
  templateUrl: './creative-card-modal.component.html',
  styleUrl: './creative-card-modal.component.scss'
})
export class CreativeCardModalComponent {

  public data!: CreativeGalleryDetailed;
  public hideNavigation = false;
  private readonly noCreativeDataText = 'Creative failed to load. Please try again.';
  private dialogData = inject(MAT_DIALOG_DATA);
  private utilService = inject(UtilService);
  public attentionMetricName = ATTENTION_METRIC_NAME;

  constructor(private dialogref: MatDialogRef<CreativeCardModalComponent>) {
    if (!this.dialogData) {
      this.utilService.openSnackBar(this.noCreativeDataText, { variant: 'error' });
      this.dialogref.close();
    }
    this.hideNavigation = this.dialogData?.hideNavigation === true;
    this.setData();
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.hideNavigation) {
      return;
    }
    switch (event.key) {
      case 'ArrowLeft':
        this.dialogref.close(GalleryNavigation.PREV);
        break;
      case 'ArrowRight':
        this.dialogref.close(GalleryNavigation.NEXT);
        break;
    }
  }

  public close() {
    this.dialogref.close()
  }

  public onPrevClick(): void {
    this.dialogref.close(GalleryNavigation.PREV);
  }

  public onNextClick(): void {
    this.dialogref.close(GalleryNavigation.NEXT);
  }

  public onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = new AssetVersionPipe().transform('images/no-logo.png');
  }

  private setData() {
    this.data = {
      cpm: this.dialogData.cpm.toFixed(2),
      attention: round(this.dialogData.attention, 2) as number,
      viewability: round(this.dialogData.viewability, 2) as number,
      minImpressions: this.dialogData.minImpressions as number,
      maxImpressions: this.dialogData.maxImpressions as number,
      ctr: this.dialogData.ctr,
      firstSeen: this.dialogData.firstSeen ? new Date(this.dialogData.firstSeen).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : 'N/A',
      lastSeen: this.dialogData.lastSeen ? new Date(this.dialogData.lastSeen).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : 'N/A',
      brandName: this.dialogData.brandName,
      id: this.dialogData.id,
      imgUrl: this.dialogData.imgUrl,
      timeInView: this.dialogData.timeInView,
      logoPath: this.dialogData.logoPath,
      size: this.dialogData.size,
    }
  }
}
